module.exports = __webpack_public_path__ + "static/tesco-card-047fc663ab6da62bac26f4538642750c.png";